import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import FormBtn from "app/Components/CommanComponents/FormBtn";
import FormSelect from "app/Components/_form/FormSelect/FormSelect";
import Decline from "app/_pages/_healthSafetyEnvironment/IncidentManagement/DeclinePopup";
import { isUserVTO } from "app/_pages/_healthSafetyEnvironment/IncidentManagement/Helper";
import {
  getTrainingBatchById,
  uploadBatchDocument,
  updateAssignersStatus,
} from "app/_services/ehs/ehsTrainingServices";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Col, Row, Button, Modal } from "react-bootstrap";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { FaCheck, FaUserMinus } from "react-icons/fa";
import {
  TRAINING_STATUS,
  TRAINING_TYPE,
  TRAINING_TYPE_VIEW,
  trainerTypeObj,
  trainerTypeView,
} from "../../CONSTANTS";
import { confirmAlert } from "react-confirm-alert";
import toastr from "toastr";
import {
  absentTraineeStatus,
  addTrainingToBatch,
  getAllTrainingBatches,
  removeTraineeStatue,
} from "app/_services/ehs/ehsTrainingServices";
import TrainingCompletedForm from "./TrainingCompletedForm";
import { useHistory } from "react-router-dom";
import SingleFileUpload from "app/views/custom/components/FileUpload/SingleFileUpload";
import CompletionProof from "app/_pages/_healthSafetyEnvironment/CapaManagement/CompletionProof";

function TrainingBatchView({ batchId, editRow, trainings, trainingInitialData }) {
  const [batchData, setBatchData] = useState({});
  const [tableList, setTableList] = useState([]);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState({});
  const [uploadFileForm, setUploadFileForm] = useState({});

  const getTrainingBatch = useCallback(() => {
    getTrainingBatchById(batchId).then((response) => {
      if (!response?.data) return;

      setBatchData(response?.data);
      //   setInitialBatches(response?.data);
      const otherTraineeTypeData = response?.data?.traineeTypeOtherData
        ? response?.data?.traineeTypeOtherData?.map((d) => {
            return {
              trainingTypeView: TRAINING_TYPE_VIEW.other,
              traineeTypeView: "Other",
              traineeName: d?.name,
              ehsSite: response?.data?.ehsSite,
              trainingCategoryName: "Not Applicable",
              trainingSubCategoryName: "Not Applicable",
            };
          })
        : [];
      setTableList([...response?.data.traineeList, ...otherTraineeTypeData]);
    });
  }, [batchId]);

  useEffect(() => {
    getTrainingBatch();
  }, [batchId, getTrainingBatch]);

  //
  const initialData = useCallback(async () => {
    if (trainingInitialData) trainingInitialData();

    getTrainingBatch();
  }, [batchId, trainingInitialData]);

  const history = useHistory();
  const dueTraining = useMemo(() => {
    if (!batchId) return [];

    // console.log("trainings", batchData?.traineeList);

    return trainings
      ?.filter(
        (d) =>
          d.trainingStatus === TRAINING_STATUS.due &&
          d.trainingType === batchData?.traineeList?.find((d) => d.id)?.trainingType
      )
      ?.map((d) => ({ label: d.traineeID, id: d.id }));
  }, [batchData, trainings, batchId]);

  const removeUser = useCallback(
    (e, id) => {
      e.preventDefault();

      confirmAlert({
        title: `${
          batchData?.traineeList?.length == 1 ? "Remove User and Batch" : "Remove User"
        }`,
        message: "Do you want to proceed?",
        buttons: [
          {
            label: "Yes",
            onClick: async () => {
              let response = await removeTraineeStatue(id);

              if (batchData?.traineeList?.length == 1) {
                history.goBack();
                return;
              }
              if (response?.status) {
                toastr.success(response?.message);
                initialData();
              }
            },
          },
          {
            label: "No",
            onClick: () => {},
          },
        ],
      });
    },
    [batchData?.traineeList?.length, history, initialData]
  );

  const absentUser = useCallback(
    (e, id) => {
      e.preventDefault();

      confirmAlert({
        title: "Absent user",
        message: "Do you want to proceed?",
        buttons: [
          {
            label: "Yes",
            onClick: async () => {
              let response = await absentTraineeStatus(id);

              if (response?.status) {
                toastr.success(response?.message);
                initialData();
              }
            },
          },
          {
            label: "No",
            onClick: () => {},
          },
        ],
      });
    },
    [initialData]
  );

  const onChangeFile = async (responseData) => {
    // setUploadFileForm((prevForm) => ({
    //     ...prevForm,
    //     documentId: responseData.id,
    //     batchId: batchId
    // }));
    setBatchData((prev) => ({
      ...prev,
      documentId: responseData.id,
      document: responseData,
    }));
    await uploadDocument({
      documentId: responseData.id,
      batchId: batchId,
    });
  };
  const uploadDocument = async (uploadFileFormData) => {
    // console.log(uploadFileForm);
    await uploadBatchDocument(uploadFileFormData).then((response) => {
      toastr.success(response?.message || "Success");
    });
  };
  const onDeleteFile = async () => {
    // setUploadFileForm((prevForm) => ({
    //     ...prevForm,
    //     documentId: null,
    //     batchId: batchId
    // }));
    setBatchData((prev) => ({
      ...prev,
      documentId: null,
      document: null,
    }));

    await uploadDocument({
      documentId: null,
      batchId: batchId,
    });
  };

  const onSubmitBatch = useCallback(async () => {
    if (!form?.trainingId) return toastr.info("Please select training");

    const obj = {
      traineesId: [form?.trainingId],
      batchId: batchId,
    };

    const result = await addTrainingToBatch(obj);

    if (result?.status) {
      toastr.success(result?.message || "Success");

      initialData();
      setShowModal(false);
      setForm({});
    }
  }, [form?.trainingId, initialData, batchId]);
  const addToBatch = () => {
    setShowModal(true);
  };

  const onChangeBatch = ({ target: { name, value, type, checked } }) => {
    setForm((prevForm) => {
      const updates = {
        ...prevForm,
        [name]: type === "checkbox" ? checked : value,
      };

      return { ...updates };
    });
  };

  const onSubmit = useCallback(
    async (obj, extraObj) => {
      const result = await updateAssignersStatus(obj);

      if (result?.status) {
        toastr.success(result?.message || "Success");

        initialData();
      }
    },
    [initialData]
  );
  const sortableColumn = [
    {
      dataField: "sid",
      text: "S.No.",
      sort: true,
    },
    {
      dataField: "traineeTypeView",
      text: "Staff Type",
      sort: true,
    },
    {
      dataField: "traineeName",
      text: "Trainee Name",
      sort: true,
    },
    {
      dataField: "trainingTypeView",
      text: "Training Type",
      sort: true,
    },
    {
      dataField: "ehsSite.name",
      text: "Location",
      sort: true,
    },
    {
      dataField: "trainingCategoryName",
      text: "Skill Category",
      sort: true,
    },
    {
      dataField: "trainingSubCategoryName",
      text: "Skill Sub Category",
      sort: true,
    },
    {
      dataField: "trainingStatusView",
      text: "Status",
      sort: true,
    },
    {
      dataField: "ID",
      text: "Action",
      sort: true,
      formatter: (cell, row, rowIndex) => {
        // console.log("row.trainingStatus === TRAINING_STATUS.scheduled", row.trainingStatus, TRAINING_STATUS.scheduled);
        return (
          <div className="actionIconsGroup">
            {row.trainingStatus === TRAINING_STATUS.scheduled && isUserVTO() && (
              <>
                <TrainingCompletedForm
                  onSubmit={(obj) =>
                    onSubmit({
                      ...obj,
                      assigneeIds: [row.id],
                      trainingStatus: TRAINING_STATUS.soReview,
                    })
                  }
                  title="Training Completed"
                  name={
                    <CustomTooltip tooltip="Training Completed">
                      <FaCheck />
                    </CustomTooltip>
                  }
                  iconClass={"icons text-success"}
                  batchData={batchData}
                  isOtherTraining={row?.trainingType === TRAINING_TYPE.other}
                />
                <CustomTooltip tooltip="Absent">
                  <span
                    // href="#"
                    className="icons text-warning pointer"
                    onClick={(e) => absentUser(e, row.id)}
                  >
                    <FaUserMinus />
                  </span>
                </CustomTooltip>
                <CustomTooltip tooltip="Remove from Batch">
                  <span
                    // href="#"
                    className="icons text-danger  pointer"
                    onClick={(e) => removeUser(e, row.id)}
                  >
                    <AiOutlineCloseCircle />
                  </span>
                </CustomTooltip>
              </>
            )}
          </div>
        );
      },
    },
  ];

  console.log("batchData", batchData);
  return (
    <>
      {batchId && isUserVTO() && !editRow && (
        <div
          style={{
            marginRight: "315px",
            position: "absolute",
            right: 0,
            top: "9px",
          }}
        >
          <Button onClick={addToBatch}>Add To Batch</Button>
        </div>
      )}
      <div className="addressSmlSec" style={{ paddinTop: "0", borderTop: "0" }}>
        <Row>
          <Col md={3} className="drilingView-bx">
            <h5>Training ID</h5>
            <p>{batchData?.trainingId}</p>
          </Col>
          <Col md={3} className="drilingView-bx">
            <h5>Batch ID</h5>
            <p>{batchData?.batchId}</p>
          </Col>
          <Col md={3} className="drilingView-bx">
            <h5>Date of commencement of training</h5>
            <p>{batchData?.trainingDateView}</p>
          </Col>

          <Col md={3} className="drilingView-bx">
            <h5>End Date Of Training</h5>
            <p>{batchData?.endDate}</p>
          </Col>

          <Col md={3} className="drilingView-bx">
            <h5> Number Of Days</h5>
            <p>{batchData?.numberOfDays}</p>
          </Col>
          <Col md={3} className="drilingView-bx">
            <h5>Session</h5>
            <p>{batchData?.session}</p>
          </Col>
          <Col md={3} className="drilingView-bx">
            <h5>Schedule</h5>
            <p>{batchData?.schedule}</p>
          </Col>
          <Col md={3} className="drilingView-bx">
            <h5>Name of Centre</h5>
            <p>{batchData?.centerName}</p>
          </Col>
          <Col md={3} className="drilingView-bx">
            <h5>Centre Code</h5>
            <p>{batchData?.centerCode}</p>
          </Col>
          {/* <Col md={3} className="drilingView-bx">
                        <h5>Area</h5>
                        <p>{batchData?.areaName}</p>
                    </Col> */}
          <Col md={3} className="drilingView-bx">
            <h5>Training Category (Skill Area)</h5>
            <p>{batchData?.trainingCategoryName}</p>
          </Col>
          <Col md={3} className="drilingView-bx">
            <h5>Training Category (Skill Subarea)</h5>
            <p>{batchData?.trainingSubCategoryData?.name}</p>
          </Col>
          <Col md={3} className="drilingView-bx">
            <h5>Duration (Days)</h5>
            <p>{batchData?.duration}</p>
          </Col>
          <Col md={3} className="drilingView-bx">
            <h5>Training Hours</h5>
            <p>{batchData?.trainingHours}</p>
          </Col>
          <Col md={3} className="drilingView-bx">
            <h5>Description of "Other" Training</h5>
            <p>{batchData?.descriptionOther}</p>
          </Col>
          <Col md={3} className="drilingView-bx">
            <h5>Trainer Type</h5>
            <p>{trainerTypeView[batchData?.trainerType] || ""}</p>
          </Col>
          <Col md={3} className="drilingView-bx">
            <h5>Trainer Name</h5>
            <p>
              {batchData?.trainerType
                ? batchData?.trainerType === trainerTypeObj.external
                  ? batchData?.trainerName
                  : `${batchData?.trainerData?.firstName} ${batchData?.trainerData?.lastName}`
                : ""}
            </p>
          </Col>
          {batchData?.batchStatus === "completed" && (
            <Col lg={3}>
              <div className="form-group viewbox">
                <h5 className="w-500">Upload Document</h5>
                <p className="mt-1">
                  {batchData?.document ? (
                    <CompletionProof file={batchData?.document} />
                  ) : (
                    "Not Applicable"
                  )}
                </p>
              </div>
            </Col>
          )}

          {batchData?.batchStatus == "scheduled" && (
            <Col md={3} className="drilingView-bx">
              <h5>Upload Document</h5>
              <SingleFileUpload
                clsName="form-group"
                alias={true}
                // disabled={batchData?.documentId ? true : false}
                labelName=" "
                selectedFile={batchData?.document}
                deleteDocumentFile={() => onDeleteFile()}
                onFileChange={(_event, responseData) => onChangeFile(responseData)}
              />
            </Col>
          )}
          {/* <Col md={3} className="drilingView-bx">
                        <Button onClick={uploadDocument}>
                            Upload
                        </Button>
                    </Col> */}
        </Row>
      </div>
      <SearchBootstrapTable data={tableList} columns={sortableColumn} />

      <AddTrainingToBatchModal
        onChange={onChangeBatch}
        show={showModal}
        onHide={setShowModal}
        form={form}
        onSubmit={onSubmitBatch}
        trainings={dueTraining}
        title={"Add To Batch"}
      />
    </>
  );
}

function AddTrainingToBatchModal({
  show,
  onHide,
  title = "Modal title",
  form,
  onChange,
  error,
  onSubmit,
  trainings,
  selectedBatch,
}) {
  const handleClose = () => onHide(false);

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        // size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row>
            <Col lg={12}>
              <FormSelect
                label={"Training"}
                name="trainingId"
                value={form?.trainingId}
                onChange={onChange}
                options={trainings}
                error={error?.trainingId}
                blankSelect={"Select"}
                menuPortalTarget={null}
              ></FormSelect>
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer className="justify-content-center">
          <FormBtn
            className=""
            backBtnTitle={"Close"}
            backOnClick={handleClose}
            onSubmit={onSubmit}
          />
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default TrainingBatchView;
